export default {
  name: 'RatesBilling',
  props: {
    roles: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    rates() {
      const roles = Array.isArray(this.roles) ? this.roles : [];
      return roles
        .map((role) => ({
          role: [role?.role || role?.role_name || role?.name, role?.group_name]
            .filter(Boolean)
            .join(' · '),
          amount: format_rate(role?.hourly_rate)
        }))
        .filter((rate) => rate.role && rate.amount);
    }
  }
};

function format_rate(value) {
  const amount = Number(value);
  return Number.isFinite(amount)
    ? `R ${amount.toLocaleString('en-ZA', { maximumFractionDigits: 2 })}`
    : '';
}
